import React from 'react';
import { Button } from './ui/button';
import { Plus } from 'lucide-react';
import { menuCategories } from '../mockData';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

export const MenuSectionDark = ({ onAddToCart }) => {
  return (
    <section id="menu" className="py-20 bg-black relative overflow-hidden">
      {/* Blurred fries background */}
      <div 
        className="fries-bg-blur" 
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1717294978892-cef673e1d17b)'
        }}
      ></div>
      
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-black/95 to-red-950/20"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Nuestro <span className="bg-gradient-to-r from-orange-500 to-red-600 bg-clip-text text-transparent">Menú</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Explora nuestra deliciosa selección de pollo frito crujiente y hamburguesas gourmet
          </p>
        </div>

        {/* Accordion Menu */}
        <div className="max-w-4xl mx-auto">
          <Accordion type="multiple" className="space-y-4">
            {menuCategories.map((category) => (
              <AccordionItem 
                key={category.id} 
                value={category.id}
                className="bg-gradient-to-br from-gray-900 to-black rounded-2xl shadow-lg shadow-red-900/20 overflow-hidden border-2 border-gray-800 hover:border-orange-500/50 transition-all"
              >
                <AccordionTrigger className="px-6 py-4 hover:no-underline group">
                  <div className="flex items-center justify-between w-full text-left">
                    <div>
                      <h3 className="text-2xl font-bold text-white group-hover:text-transparent group-hover:bg-gradient-to-r group-hover:from-orange-500 group-hover:to-red-600 group-hover:bg-clip-text transition-all">
                        {category.name}
                      </h3>
                      {category.description && (
                        <p className="text-sm text-gray-400 mt-1">{category.description}</p>
                      )}
                    </div>
                  </div>
                </AccordionTrigger>
                
                <AccordionContent className="px-6 pb-6">
                  <div className="space-y-3 pt-2">
                    {category.items.map((item) => (
                      <div
                        key={item.id}
                        className="flex items-center justify-between p-4 bg-gradient-to-r from-red-950/20 to-orange-950/20 rounded-xl hover:from-red-900/30 hover:to-orange-900/30 border border-gray-800 hover:border-orange-500/50 transition-all group"
                      >
                        <div className="flex-1">
                          <h4 className="font-semibold text-white text-lg">{item.name}</h4>
                          {item.description && (
                            <p className="text-sm text-gray-400 mt-1">{item.description}</p>
                          )}
                        </div>
                        
                        <div className="flex items-center space-x-4 ml-4">
                          <span className="text-2xl font-bold bg-gradient-to-r from-orange-500 to-red-600 bg-clip-text text-transparent whitespace-nowrap">
                            ${item.price}
                          </span>
                          <Button
                            size="sm"
                            className="bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700 opacity-0 group-hover:opacity-100 transition-opacity shadow-lg shadow-red-900/50"
                            onClick={() => onAddToCart(item)}
                          >
                            <Plus className="h-4 w-4 mr-1" />
                            Agregar
                          </Button>
                        </div>
                      </div>
                    ))}
                  </div>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        {/* Note */}
        <div className="text-center mt-12">
          <p className="text-gray-400 italic">
            * Todos nuestros productos son preparados al momento con ingredientes frescos
          </p>
        </div>
      </div>
    </section>
  );
};
